import { Button } from "../../../components/ui/button";
import { Label } from "../../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";

const LeadFilters = ({ filterStatus, setFilterStatus, filterPriority, setFilterPriority }) => {
  const isFiltered = filterStatus !== "all" || filterPriority !== "all";

  return (
    <div className="flex flex-wrap gap-4 items-center">
      <div className="flex items-center gap-6 bg-white dark:bg-yale-blue-900 p-4 rounded-xl shadow-sm border border-slate-200 dark:border-yale-blue-800">
        <div className="flex items-center gap-2">
          <Label className="font-medium text-slate-600 dark:text-slate-400 whitespace-nowrap">Status:</Label>
          <Select value={filterStatus} onValueChange={setFilterStatus}>
            <SelectTrigger className="w-44 border-slate-200 dark:border-yale-blue-800 focus:ring-primary">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="new">New</SelectItem>
              <SelectItem value="contacted">Contacted</SelectItem>
              <SelectItem value="meeting_scheduled">Meeting Scheduled</SelectItem>
              <SelectItem value="proposal_sent">Proposal Sent</SelectItem>
              <SelectItem value="won">Won</SelectItem>
              <SelectItem value="lost">Lost</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2 border-l pl-6 border-slate-200 dark:border-yale-blue-800">
          <Label className="font-medium text-slate-600 dark:text-slate-400 whitespace-nowrap">Priority:</Label>
          <Select value={filterPriority} onValueChange={setFilterPriority}>
            <SelectTrigger className="w-40 border-slate-200 dark:border-yale-blue-800 focus:ring-primary">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Priority</SelectItem>
              <SelectItem value="low">Low</SelectItem>
              <SelectItem value="medium">Medium</SelectItem>
              <SelectItem value="high">High</SelectItem>
              <SelectItem value="urgent">Urgent</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {isFiltered && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            setFilterStatus("all");
            setFilterPriority("all");
          }}
          className="dark:border-yale-blue-800 dark:text-slate-400 dark:hover:bg-yale-blue-800"
        >
          Clear Filters
        </Button>
      )}
    </div>
  );
};

export default LeadFilters;
